define([
	"dojo/_base/declare",
	"./StringTextarea",
	"./_LocalizedMixin"
], function(declare,StringTextarea,_LocalizedMixin) {

	return declare([StringTextarea,_LocalizedMixin], {
	});
});